import styled from 'styled-components';
// import theme from '../theme';

const InvitationModalStyles = styled.div``;

export default InvitationModalStyles;
